var React = require('react');

var Collapsable = React.createClass({

  collapsed: true,

  componentDidMount: function() {
    jQuery(window).scroll();
    var content = this.props.item.content;

    if (content.indexOf('&gt;') >= 0) {
      content = jQuery('<div/>').html(content).text();
      jQuery(this.refs.content).append(content);
    } else {
      jQuery(this.refs.content).append(jQuery('<p/>').html(content));
    }
  },

  render: function() {
    var id = "faq" + this.props.index;

    return <div className="collapsable-row">
                <div className="">
                    <h3><a className="accordion-toggle collapsed" data-toggle="collapse"
                           href={'#' + id} role="button">{this.props.item.title}</a></h3>
                    <div ref="content" className="collapse collapsable-content" id={id}>
                    </div>
                </div>
            </div>
    }
  });

module.exports = React.createClass({

  render: function() {
    var postList = _.map(this.props.items,
                       function(item, index) {
                         return <Collapsable item={item}
                                             index={this.props.blogIndex + "-" + index}
                                             key={index} />
                       }.bind(this));
    return <div className={"collapsable-group" + (this.props.noFade ? "" : " fade-in")}>
        <h2>{this.props.name}</h2>
        <div className="accordion" >
        {postList}
        </div>
      </div>
  }
});